import React from "react";
import { Box } from "@mui/material";
import { WidgetFabChevronIcon, WidgetFabIcon } from "../widgetPreviewIcons";

function WidgetFab({ color, position = "right", variant = "chat" }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: position === "left" ? "flex-start" : "flex-end",
        width: "100%",
        mt: "12px",
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(6, 21, 34, 0.15)",
        }}
      >
        {variant === "chevron" ? <WidgetFabChevronIcon /> : <WidgetFabIcon />}
      </Box>
    </Box>
  );
}

export default React.memo(WidgetFab);
